<template>
    <div class="depart-manage">
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>部门管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="70px">
                <el-form-item label="系统">
                    <el-select size="small" v-model="formInline.companyId" placeholder="请选择系统" filterable clearable :filter-method="dataFilter">
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门名称">
                    <el-input size="small" v-model="formInline.menuName" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" size="small" type="primary" @click="onSubmit">查 询</el-button>
                    <!-- <el-button icon="el-icon-plus" size="small" type="primary" @click="changeDepartInfo">新 增</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
            <el-table
                v-loading="loading"
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="groupId"
                :header-cell-style="{ background: '#eef1f6', color: '#606266', fontWeight: 'bolder' }"
                tooltip-effect="dark"
                default-expand-all
                :tree-props="{ children: 'children', hasChildren: 'hasChildren'} ">
                <el-table-column
                    type="index"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="groupName"
                    label="部门名称">
                </el-table-column>
                <el-table-column
                    prop="sortNo"
                    label="排序">
                </el-table-column>
                <el-table-column
                    prop="sortNo"
                    label="显示顺序">
                </el-table-column>
                <el-table-column
                    label="创建时间"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="groupDesc"
                    label="备注">
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { getDepartInfoLists, addDepart, deleteDepart, changeDepart } from '@/api/departMange'
import { getSystemData } from "@/api/systemMange";
import { dateFilter } from '@/utils';
import { hasBtnPermission } from '@/utils';
export default {
    name: "DepartManage",
    data(){
        return {
            loading: false,
            title: '',
            changeVisible: false, // 外层dialog
            innerVisible: false, // 内层dialog
            companyOptions: [],
            formInline: {
                companyId: ''
            },
            tableData: [],
            ruleForm: {
                companyId: '',
                groupParentId: 0,
                groupParentName: '',
                groupDesc: '',
                groupName: '',
                groupTypeId: '',
                sortNo: '',
                userCode: ''
            },
            rules: {
                companyId: [
                    { required: true, message: '请选择系统', trigger: 'blur' }
                ],
                groupParentId: [
                    { required: true, message: '请选择上级部门', trigger: 'blur' }
                ],
                groupName: [
                    { required: true, message: '请输入部门名称', trigger: 'blur' }
                ],
                sortNo: [
                    { required: true, message: '请选输入显示排序', trigger: 'blur' }
                ]
            },
            departTreeList: [],
            defaultProps: {
                children: 'children',
                label: 'groupName'
            },
            searchSystemParams: {
                pageNo: 1,
                pageSize: 100,
                companyName: '',
                userCode: ''
            },
            selectParent: [],
            i: 0
        }
    },
    activated() {
        this.getAllSystemInfo().then(() => {
            !this.formInline.companyId && (this.formInline.companyId = this.companyOptions[0].companyId)
            this.onSubmit()
        })
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo(){
            this.searchSystemParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
            const res = await getSystemData(this.searchSystemParams);
            if(res.code == 200){
                this.companyOptions = res.data.list
            }else{
                this.$message.error(res.msg)
            }
        },
        // 查询所有部门信息
        async getDepartList(){
            this.loading = true
            this.departTreeList = []
            this.formInline.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await getDepartInfoLists(this.formInline)
            if(res.code === '200'){
                this.tableData = res.data
                this.departTreeList = res.data
            }else{
                this.$message.error(res.msg)
                this.tableData = []
            }
            this.loading = false
        },
        // 弹出dialog
        changeDepartInfo(item){
            if(item.groupName){
                if(!hasBtnPermission('sys:group:update')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.$router.push({
                    path: '/sys/group/addDepart',
                    query: { item: JSON.stringify(item) }
                })
                this.title = '编辑'
            }else{
                if(!hasBtnPermission('sys:group:save')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.$router.push({
                    path: '/sys/group/addDepart',
                })
                this.title = '新增'
            }
        },
        // 删除部门数据
        deleteDepartItem(item){
            if(!hasBtnPermission('sys:group:delete')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$confirm('确定删除该数据吗？','提示')
                .then(_ => {
                    this.confirmDeleteDepartItem(item)
                })
                .catch(_ => {})
        },
        // 确认删除部门数据
        async confirmDeleteDepartItem(item){
            let params = {
                groupId: item.groupId,
                companyId: item.companyId
            }
            const res = await deleteDepart(params)
            if(res.code === '200'){
                this.$message.success('删除成功')
                this.getDepartList()
            }else{
                this.$message.error(res.msg)
            }
        },
        onSubmit(){
            if(!hasBtnPermission('sys:group:list')){
                this.$message.warning('您暂无权限操作')
                return
            }
            if(!(this.formInline.companyId >= 0)){
                this.$message.warning('请先选择系统')
                return
            }
            this.getDepartList()
        },
        // 搜索查询
        dataFilter(e){
            this.searchSystemParams.companyName = e;
            this.getAllSystemInfo()
        },
    }
}
</script>
<style scoped>
::v-deep .el-card__body{
    padding: 20px 20px 0 20px;
}
</style>
<style scoped lang="scss">
.el-table--fit{
    padding-bottom: 20px;
}
</style>
